import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useRepsOutletContext } from 'pages/Reps.context'
import { useParams } from 'react-router-dom'
import { AssociarFuncionarioForm } from '../forms/AssociarFuncionarioForm'

export default function AssociarFuncionariosRep() {
    const { id } = useParams()
    const { data } = useRepsOutletContext()

    const r = data?.find(item => item.id === Number(id))

    if (!r) return null

    return (
        <Dialog.Root defaultValues={r} open={hasPermission(['update', 'Reps'])}>
            <Dialog.Title>Associar funcionários</Dialog.Title>
            <Dialog.Content>
                <AssociarFuncionarioForm />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
